/**
 * Exporta un arreglo de objetos como CSV utilizando blobs.
 * @param {Object} options
 * @param {string} options.filename Nombre sugerido del archivo.
 * @param {{ label: string, key: string }[]} options.columns Definición de columnas.
 * @param {Array<Record<string, any>>} options.rows Registros a exportar.
 */
export function exportCsv({ filename = 'export.csv', columns = [], rows = [] }) {
  if (!columns.length || !rows.length) {
    console.warn('exportCsv: se requieren columnas y filas para exportar.');
  }

  const safeColumns = columns.length
    ? columns
    : Object.keys(rows[0] || {}).map(key => ({ label: key, key }));

  const header = safeColumns.map(column => escapeValue(column.label)).join(',');
  const body = rows
    .map(row => safeColumns.map(column => escapeValue(row[column.key])).join(','))
    .join('\n');
  const csvContent = [header, body].filter(Boolean).join('\n');

  const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.setAttribute('download', filename);
  link.style.display = 'none';
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
}

function escapeValue(value) {
  if (value === null || value === undefined) {
    return '';
  }
  const stringValue = String(value);
  if (/[",\n]/.test(stringValue)) {
    return `"${stringValue.replace(/"/g, '""')}"`;
  }
  return stringValue;
}

export default exportCsv;
